import React from 'react';
import './MembershipProgress.scss';

interface MembershipProgressProps {
  currentLevel: string;
  nextLevelName?: string;
  totalSpent: number;
  nextLevelRequiredSpent: number;
}

const MembershipProgress: React.FC<MembershipProgressProps> = ({
  currentLevel,
  nextLevelName,
  totalSpent,
  nextLevelRequiredSpent
}) => {
  // Calculate progress percentage
  const spent = totalSpent ;
  const required = nextLevelRequiredSpent;
  const progressPercentage = Math.min((spent / required) * 100, 100);

  // Format Chilean pesos
  const formatCLP = (amount: number): string => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="membership-progress">
      <div className="progress-header">
        <span className="current-level">{currentLevel}</span>
        {nextLevelName && (
          <span className="next-level">→ {nextLevelName}</span>
        )}
      </div>
      
      <div className="progress-bar-container">
        <div 
          className="progress-bar-fill" 
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      
      {nextLevelName && (
        <div className="progress-text">
          <span className="spent-amount">{formatCLP(totalSpent)}</span>
          <span className="required-amount">
            {formatCLP(nextLevelRequiredSpent - totalSpent)} para {nextLevelName}
          </span>
        </div>
      )}
    </div>
  );
};

export default MembershipProgress;
